import React, { useMemo } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import { useQuery } from "react-query";
import { Spin, Tag } from "antd";
import "../../Styles/style.css";
import TableContainerMin from "../../../Components/Common/TableContainer";

const Documents = ({ user }) => {
  
  const columns = useMemo(
    () => [
        { Header: "Nom", accessor: "fileName",filterable: false },
        { Header: "Type", accessor: "model", filterable: false },
        { Header: "Créé le", accessor: "createdAt", filterable: false },
    ],
    []
  );

  return (
    <Card id="contactList">
      <CardHeader>
        Les documents lié au chauffeur {user?.name || "-"}
      </CardHeader>
      <CardBody className="pt-0">
        <TableContainerMin
          columns={columns}
          data={[]}
          isGlobalSearch={true}
          isGlobalFilter={true}
          customPageSize={5}
          className="custom-header-css"
          divClass="table-responsive table-card mb-3"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
        />
        {/* {isLoading && !isError && (
          <div className="text-center">
            Chargement... <Spin />
          </div>
        )}
        {user && user.length === 0 && !isLoading && (
          <div>Erreur lors du chargement, {error || error?.message}</div>
        )} */}
      </CardBody>
    </Card>
  );
};

export default Documents;
